import React from 'react'
import HelpCenterHero from './HelpCenterHero'

function FooterHelpCenter() {
    return (
        <div>
            HelpCenter Pages
            <HelpCenterHero />
        </div>
    )
}

export default FooterHelpCenter
